import { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'

import useFetch from 'hooks/useFetch'
import useFilter from 'hooks/useFilter'
import usePagination from 'hooks/usePagination'
import useSelectOptions from 'hooks/useSelectOptions'

import { useTheme } from '@material-ui/styles'
import { Skeleton } from '@material-ui/lab'
import {
  Box,
  Button,
  Divider,
  Card,
  Grid,
  Tab,
  Tabs,
  TablePagination,
  Typography,
  useMediaQuery,
} from '@material-ui/core'
import {
  Container,
  ContentHeader,
  FilterButton,
  Filters,
  Page,
  Permitted,
} from 'components'
import { PartnerServicesTable } from './components'

import { Plus as PlusIcon } from 'react-feather'

import constants from 'constants/index'
import * as service from 'service'

import { routes } from 'Routes'

const PartnerServicesMain = () => {
  const history = useHistory()
  const filter = useFilter()
  const theme = useTheme()
  const selectOptions = useSelectOptions()
  const [loading, setLoading] = useState(false)
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })

  const [currentTab, setCurrentTab] = useState(
    constants.partnerService.ACTIVE_STATUS,
  )

  const { perPage, page, handleChangePage, handleChangeRowsPerPage } =
    usePagination(10)

  useEffect(() => {
    selectOptions.loadData({ list_all: true })

    //eslint-disable-next-line
  }, [selectOptions.reload, page, perPage, filter.filters])

  const { response, isLoading, refresh } = useFetch(
    service.marketPlace.partnerService.get,
    {
      ...{ ...filter.filters },
      status: currentTab,
      perPage,
      page,
    },
    [page, perPage, filter.filters],
  )

  const handleChangeTabs = (event, value) => {
    setCurrentTab(value)
    filter.setFilters({ ...filter.filters, status: value })
  }

  return (
    <Page title="Todos os serviços">
      <Container maxWidth={false} spacingXl={30} spacingLg={10}>
        <ContentHeader menu="Serviços" title="Listagem" subtitle="Todos">
          <FilterButton setDrawerOpen={filter.setDrawerOpen} />
        </ContentHeader>
        <Tabs
          scrollButtons="on"
          onChange={handleChangeTabs}
          textColor="primary"
          indicatorColor="primary"
          value={currentTab}
          variant="scrollable"
        >
          {constants.partnerService.TABS.map((tab) => (
            <Tab key={tab.value} value={tab.value} label={tab.label} />
          ))}
        </Tabs>
        <Divider />
        <Box mt={3}>
          <Card>
            <Box display="flex" width="100%" p={0}>
              <Grid container>
                <Grid item xs={6}>
                  <Box
                    width="100%"
                    p={2}
                    height="100%"
                    display="flex"
                    alignItems="center"
                  >
                    <Typography variant="h5">Serviços</Typography>
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box p={2} display="flex" justifyContent="flex-end">
                    <Permitted tag={constants.permissions.SERVICES.CREATE}>
                      <Button
                        variant="outlined"
                        color="primary"
                        startIcon={<PlusIcon />}
                        onClick={() => history.push(routes.services.new)}
                      >
                        Criar
                      </Button>
                    </Permitted>
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <Divider />
            <Box display="flex" width="100%">
              <Grid container>
                <PartnerServicesTable
                  partnerServices={response?.data?.partnerServices}
                  isLoading={
                    isLoading || loading || selectOptions.isLoadingOptions
                  }
                  onEvent={refresh}
                  setLoading={setLoading}
                />
              </Grid>
            </Box>
            <Box px={2} display="flex" justifyContent="flex-end">
              {!isLoading || loading ? (
                <TablePagination
                  component="div"
                  count={response?.data?.meta?.totalCount}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  page={page - 1}
                  rowsPerPage={perPage}
                  rowsPerPageOptions={[5, 10, 25, 100]}
                  labelRowsPerPage={isDesktop ? 'Por página' : ''}
                  nextIconButtonProps={{ size: 'small' }}
                  backIconButtonProps={{ size: 'small' }}
                />
              ) : (
                <Box py="11px">
                  <Skeleton variant="rect" width={200} height={30} />
                </Box>
              )}
            </Box>
          </Card>
        </Box>
        {!isLoading && !loading && !selectOptions.isLoadingOptions && (
          <Filters filter={filter}>
            <input textfieldinput="true" label="Identificador" name="id" />
            <input textfieldinput="true" label="Descrição" name="description" />
            <input price="true" label="Preço Mínimo" name="priceGt" />
            <input price="true" label="Preço Máximo" name="priceLt" />
            {selectOptions.companyServices && (
              <select
                autocomplete="true"
                label="Nome do serviço"
                name="companyServiceId"
                optionvalues={selectOptions.companyServices}
              />
            )}
            <input
              datepickerinput="true"
              label="Data de criação inicial"
              name="createdAtGt"
              data-target="createdAtLt"
              data-min
            />
            <input
              datepickerinput="true"
              label="Data de criação final"
              name="createdAtLt"
              data-target="createdAtGt"
              data-max
            />
          </Filters>
        )}
      </Container>
    </Page>
  )
}

export default PartnerServicesMain
